import React, { Component } from "react";
import "../assets/sales-assets/bootstrap/css/bootstrap.min.css";
import { Chart } from 'react-chartjs-2';
import { login } from '../Services/service';
import { url } from "./config";
import firebase from 'firebase'
import logo from '../assets/sales-assets/img/logo.png'
import '../assets/sales-assets/css/styles.css'

var Chart1;

var tabSalesResponse, group1Data;

 tabSalesResponse = ""; //tabSales.body.tabSales;
 group1Data = ""; //tabSalesResponse.order.turnover.groupAll;

class SalesDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      loaded: false,
      salesType: "sales_inc_tax",
    }
  }
  componentDidMount() {
   var self = this;
   login('username', 'password')

   this.fetchTabSales();
    setInterval(() => { this.fetchTabSales(); }, (60000*1));
    window.addEventListener("resize", this.handleResize);
  }

  handleResize = (e) => {
    this.setState({ 
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    });
    window.location.reload(false);
     };
  
   componentWillUnmount() {
    window.addEventListener("resize", this.handleResize);
   } 
  

  fetchTabSales() {
    var db = firebase.database();
    var self = this;
    return db.ref('chartData').once('value')
    .then(function(snapshot) {
      var chartData = (snapshot.val());
      //console.log((chartData));
      self.updateCharts({"data": (JSON.parse(chartData))});
    });

  } 

  updateCharts(fetchDetail){
    if(fetchDetail.status != 401){
      this.tabSalesResponse = fetchDetail.data.body.tabSales;
      console.log(fetchDetail.data.body.tabSales);
      this.chartFilter();
    }else {
      localStorage.removeItem("sessionId");
      window.location.href = url.frontendUrl + 'login';
    }
  }

  chartFilter = () => {
    this.group1Data = this.tabSalesResponse;

    var type = this.state.salesType;

    this.chart1Data = [{
          label: ['Actual'],
          data: this.group1Data.chart1 ? this.group1Data.chart1.data.actual[type] : [],
          borderWidth: 7,
          pointHoverBorderWidth: 7,
          pointRadius: 10,
          pointHoverRadius: 15,
          pointBorderColor: "rgba(0,0,0,1)",
          pointBackgroundColor: "rgba(255,255,255,1)",
          backgroundColor: this.group1Data.chart1.data.trend[type][this.group1Data.chart1.data.trend[type].length-1]>this.group1Data.chart1.data.target[type][this.group1Data.chart1.data.target[type].length-1]?"rgba(40,167,69,0.8)":"rgb(183,23,35,0.8)",
          borderColor: "rgba(0,0,0,1)",
          type: 'line',
      }, {
        label: ['Target'],
        data: this.group1Data.chart1 ? this.group1Data.chart1.data.target[type] : [],
        borderWidth: 5,
        pointBorderWidth: 7,
        pointRadius: 10,
        pointHoverRadius: 15,
        pointHoverBorderWidth: 7,
        backgroundColor: "rgba(220,220,220,1)",
        borderColor: "rgba(200,200,200,1)",
        pointBackgroundColor: "rgba(255,255,255,1)",
        type: 'line',
      }, {
          label: ['Trend'],
          data: this.group1Data.chart1 ? this.group1Data.chart1.data.trend[type] : [],
          borderWidth: 7,
          pointBorderWidth: 7,
          pointHoverBorderWidth: 7,
          pointRadius: 10,
          borderDash: [10,10],
          pointHoverRadius: 15,
          backgroundColor: "rgba(220,220,220,1)",
          pointBorderColor: this.group1Data.chart1.data.trend[type][this.group1Data.chart1.data.trend[type].length-1]>this.group1Data.chart1.data.target[type][this.group1Data.chart1.data.target[type].length-1]?"rgba(40,167,69,0.8)":"rgb(183,23,35,0.8)",
          fill: false,
          type: 'line',
        },
        {label: ['Prev Week'],
        data: this.group1Data.chart1 ? [null,null,null,null,null,null,this.group1Data.chart1.data.actual_lw[type]] : [],
        type: 'scatter',
        pointBorderWidth: 7,
        pointHoverBorderWidth: 7,
        pointRadius: 10,
        pointHoverRadius: 15,
        backgroundColor: "rgba(190,228,248,1)",
        borderColor: "rgba(167,218,246,1)",
      }
      ]

    console.log(this.chart1Data);
    this.showCharts();
  }

  showCharts = () => {
    const { windowWidth,windowHeight } = this.state; 

    var ctx1 = document.getElementById("chart1");

    var options = {
        scales: {
          yAxes: [{
            ticks: {
              reverse: false,
              beginAtZero: true,
              fontSize:20,
              fontStyle: 'bold',
            },
          }],
          xAxes: [{
            ticks: {
              fontSize: windowWidth > 600 ? 30 : 20,
              fontStyle: 'bold',
                }
          }],
        },
        legend:{
          labels:{
            fontSize: 20
          }
        }
    }

    if(Chart1){
      Chart1.destroy();
    }

    Chart1 = new Chart(ctx1, {
      data: {
        labels: this.group1Data.chart1 ? this.group1Data.chart1.data.label : null,
        fill: false,
        datasets: this.chart1Data
      },
      options: options,
    });

    this.setState({loaded: true})

  }

  setProfit(){
    this.setState({"salesType":"profit"});
    this.chartFilter();
  }

  setTurnover(){
    this.setState({"salesType":"sales_inc_tax"});
    this.chartFilter();
  }

  render() {
    const { windowWidth,windowHeight } = this.state; 
    const classes = this.state.loaded ? 'logo loaded' : 'logo'

    return (
          <div>
                  <div style={{ position: "absolute", top: '15px', right: '15px', zIndex: 10}}
                    class="btn-group btn-group-toggle float-left" data-toggle="buttons">
                    <label id="toggle-sales-value1" onClick={() => this.setProfit()} className={"btn btn-primary " + (this.state.salesType== "profit" ? 'active' : '')}>GP<input type="radio" name="toggle-sales" /></label>
                    <label id="toggle-sales-value2" onClick={() => this.setTurnover()} className={"btn btn-primary " + (this.state.salesType== "sales_inc_tax" ? 'active' : '')}>TO<input type="radio" name="toggle-sales" checked="" /></label></div>            
          <div class="col" style={{ padding:30}}>
            <div style={{ height: windowHeight-60, width: windowWidth-60 }}>
              <canvas id="chart1" width={(windowWidth-60)} height={(windowHeight-60)} class="chartjs-render-monitor"></canvas>
            </div>
        </div>
        <div className="img-wrap"><img className={classes} src={logo} alt="Scandia Pumps AB"></img></div>
        </div>
    );
  }
}
export default SalesDashboard;